import { createContext } from 'react';

import { ValidationState } from '../Types';

export interface LabelContextValue {
  id?: string;
  state?: ValidationState;
  describedBy?: string;
}

export const LabelContext = createContext<LabelContextValue>({});
